export const MY_TAX_CHECKING_TITLE = 'Секундочку..';

export const MY_TAX_CHECKING_STATUS_DESCRIPTION =
	'Проверяем наличие статуса ИНН, обычно это занимает 10–30 секунд';

export const MY_TAX_CHECKING_PERMISSIONS_DESCRIPTION =
	'Проверяем наличие прав у ФНС, обычно это занимает 10–30 секунд';

export const PARTNER_AGREEMENT_CHECKING_DESCRIPTION =
	'Проверяем подтверждение Альфа-банка. Это может занять несколько минут';

export type MyTaxCheckingMode = 'status' | 'permissions';

export const getMyTaxCheckingDescription = (mode: MyTaxCheckingMode): string => {
	// Альфа-подтверждение анкеты — отдельный шаг PartnerAgreementChecking со своим текстом.
	return mode === 'status'
		? MY_TAX_CHECKING_STATUS_DESCRIPTION
		: MY_TAX_CHECKING_PERMISSIONS_DESCRIPTION;
};
